'use strict';

import $ from '@nuskin/nuskinjquery';
import angular from 'angular';

import '../app.js';
import {AdrConstants, CartService, AdrService} from '@nuskin/ns-shop';
import {getStrings} from '../util/stringUtil';

angular.module('checkout').controller('AdrShipWhenCtrl', ['$scope', 'nsADRType', 'nsAdrUtil', async function($scope, nsADRType, nsAdrUtil) {    // eslint-disable-line
    if (window.ReactNativeWebView) {
        $scope.hideHeader = true;
        $scope.hideFooter = true;
    }
    const adrOptions = await nsAdrUtil.getAdrOptions();

    $scope.tdc = await getStrings();
    $scope.adrType = {};

    /**
     * init
     */
    function init() {
        // setup the shipNowFuture dialog
        if (adrOptions.get(AdrConstants.ADR_MODE) === AdrConstants.IMMEDIATE_FUTURE) {
            $scope.option1Label = $scope.tdc.shipImmediateLabel;
            $scope.option2Label = $scope.tdc.shipFutureLabel;
            $scope.adrType.holder = nsADRType.getADRType();
            // The adrType needs to be the selected option, not a copy of it, for the radio button to be selected.
            $scope.adrTypeValues = {
                one: nsADRType.equals($scope.adrType.holder, AdrConstants.IMMEDIATE) ? $scope.adrType.holder : AdrConstants.IMMEDIATE,
                two: nsADRType.equals($scope.adrType.holder, AdrConstants.FUTURE) ? $scope.adrType.holder : AdrConstants.FUTURE
            };
        } else if (adrOptions.get(AdrConstants.ADR_MODE) === AdrConstants.DEFAULT_ALWAYS) {
            $scope.option1Label = $scope.tdc.defaultShipLabel;
            $scope.option2Label = $scope.tdc.shipAlwaysLabel;
            $scope.adrType.holder = AdrConstants.DEFAULT;
            if (!adrOptions.get(AdrConstants.USE_DFLT_FOR_IMMEDIATE_FIRST)) {
                // DEFAULT is not a shipImmediate type unless this flag is set.
                AdrConstants.DEFAULT.isImmediate = true;
            }
            // The adrType needs to be the selected option, not a copy of it, for the radio button to be selected.
            $scope.adrTypeValues = {
                one: nsADRType.equals($scope.adrType.holder, AdrConstants.DEFAULT) ? $scope.adrType.holder : AdrConstants.DEFAULT,
                two: nsADRType.equals($scope.adrType.holder, AdrConstants.ALWAYS) ? $scope.adrType.holder : AdrConstants.ALWAYS
            };
        }

        if (CartService.hasItems({cartOrderItems: true})) {
            if (CartService.getItemData({cartAdrItems: true}).some((item) => item.isBusinessPortfolio)) {
                $scope.processFirstMessage = $scope.tdc.adrFirstMessage;
            } else {
                $scope.processFirstMessage = $scope.tdc.orderFirstMessage;
            }
        }

        /**
         * apply
         *
         * @param {function} _callback
         */
        function apply(_callback) {
            const callback = _callback || function() {};

            if ($scope.$$phase != '$apply' && $scope.$$phase != '$digest') {
                $scope.$apply(callback);
            } else {
                callback();
            }
        }

        // detect window width to determine button size.
        $scope.nsButtonSize = 'short';

        /**
         * setNsButtonHeight
         */
        function setNsButtonHeight() {
            apply(() => {
                $scope.nsButtonSize = $(window).width() >= 1023 ? 'short' : '';
            });
        }

        $(() => {
            setNsButtonHeight();

            $(window).resize(() => {
                setNsButtonHeight();
            });
        });
    }

    $scope.setAdrType = function() {
        nsADRType.setADRType($scope.adrType.holder);
    };

    $scope.continue = function() {
        const adr = AdrService.getAdrDraft();

        if (adr.shipImmediate != $scope.adrType.holder.isImmediate) {
            adr.shipImmediate = $scope.adrType.holder.isImmediate;
            AdrService.setAdrDraft(adr);
            const properties = {};
            if (!$scope.adrType.holder.isImmediate && $scope.adrType.holder.value == 'future') {
                // Tell the cart page to check for signup mode again as the BP will get removed from the cart.
                properties.checkForSignup = true;
            }
            CartService.setCartProperties(properties, true);
        }
        nsADRType.setADRType($scope.adrType.holder);
        // adrOptions.set(AdrConstants.ADR_TYPE, $scope.adrType.holder);

        CartService.goToCheckoutPage({route: 'orderSummary'});
    };

    init();
}]);
